// src/modules/notifications/model/INotification.ts

export type NotificationStatus =
  | "SCHEDULED" // Programada
  | "ACTIVE" // Ativa
  | "EXPIRED" // Expirada
  | "DELETED"; // Excluída (soft delete)

export enum NotificationStatusEnum {
  SCHEDULED = "SCHEDULED",
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
  DELETED = "DELETED",
}
export const { SCHEDULED, ACTIVE, EXPIRED, DELETED } = NotificationStatusEnum;

export interface INotificationTarget {
  centers: string[]; // codigos de centro (ex.: ["C003"])
  segments: string[]; // ex.: ["Atem"]
  profiles: string[]; // ex.: ["Cliente", "Motorista", "Transportador"]
}

export interface INotification {
  id: number;

  title: string;
  message: string;
  targets: INotificationTarget;

  startAt: string; // ISO string
  endAt: string; // ISO string

  imageUrl?: string;

  createdBy?: string;
  createdAt?: string;

  deletedBy?: string;
  deletedAt?: string;

  // Status vem “do backend”.
  // No mock recalculamos, mas mantemos o campo para ficar próximo do futuro.
  status: NotificationStatus;
}

export interface IUserNotification extends INotification {
  isRead: boolean;
}

export interface INotificationFilter {
  id?: number;
  title?: string;
  periodStart?: string; // ISO
  periodEnd?: string; // ISO
  recipient?: string; // termo para centro/segmento/perfil
  status?: NotificationStatus;
  page?: number;
  pageSize?: number;
}

export interface IPaginatedNotifications {
  items: INotification[];
  page: number;
  pageSize: number;
  total: number;
}

export interface INotificationRead {
  name: string;
  email: string;
  readAt: string;
}

export interface INotificationCreateDTO {
  title: string;
  message: string;
  targets: INotificationTarget;
  startAt: string;
  endAt: string;
  imageUrl?: string;
}

export interface INotificationUpdateDTO extends INotificationCreateDTO {
  id: number;
}

export interface IUserContextForNotification {
  name: string;
  email: string;
  centers: string[];
  segments: string[];
  profiles: string[];
}

export interface INotificationService {
  list(filter: INotificationFilter): Promise<IPaginatedNotifications>;
  getById(id: number): Promise<INotification>;
  create(data: INotificationCreateDTO, createdBy: string): Promise<void>;
  update(id: number, data: INotificationCreateDTO): Promise<void>;
  softDelete(id: number, deletedBy: string): Promise<void>;

  listReads(id: number): Promise<INotificationRead[]>;

  listActiveForUser(ctx: IUserContextForNotification): Promise<INotification[]>;

  markRead(id: number, ctx: IUserContextForNotification): Promise<void>;

  listForUserWithReadStatus(
    payloadRequest: IUserContextForNotification
  ): Promise<IUserNotification[]>;

  resetMocks(): Promise<void>;
  clearNotificationsModule(): Promise<void>;
}
